import { useState, useEffect, useCallback, useRef } from 'react';
import { getBusinessTypes, getBusinessTypesCachePeek } from '../services/businessTypesApi';

/** Backenddan; bir nechta komponent bir vaqtda mount bo‘lsa, bitta so‘rov (getBusinessTypes keshi). */
export function useBusinessTypes() {
  const [list, setList] = useState(() => {
    if (typeof window === 'undefined') return [];
    return getBusinessTypesCachePeek() ?? [];
  });
  const [loading, setLoading] = useState(() => {
    if (typeof window === 'undefined') return true;
    return getBusinessTypesCachePeek() === null;
  });
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  const fetchData = useCallback(async () => {
    const warm = getBusinessTypesCachePeek();
    if (warm) {
      if (!mountedRef.current) return;
      setList(warm);
      setLoading(false);
      setError(null);
      return;
    }
    if (!mountedRef.current) return;
    setLoading(true);
    setError(null);
    try {
      const res = await getBusinessTypes();
      if (!mountedRef.current) return;
      setList(Array.isArray(res) ? res : []);
    } catch (err) {
      if (!mountedRef.current) return;
      setError(err instanceof Error ? err : new Error(String(err)));
      setList([]);
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    void fetchData();
    return () => {
      mountedRef.current = false;
    };
  }, [fetchData]);

  return { list, data: list, loading, error, refetch: fetchData };
}
